module.exports = "<div class=\"layout-container\">\r\n  <div class=\"layout\">\r\n    <psm-section class=\"left w-70 h-100\" [id]=\"0\"></psm-section>\r\n    <psm-section class=\"right w-30 h-100\" [id]=\"1\"></psm-section>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.component.html
// module id = ./src/app/views/presentations/layouts/layouts/twoSectionsHorizontalLayoutMirror/twoSectionsHorizontalLayoutMirror.component.html
// module chunks = main